<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="userForm" *ngIf="this.userForm" (ngSubmit)="onSubmit()">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    Edit Admin
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4">
                                    <label for="firstName">First Name <span class="mandatory-fields">*</span></label>
                                    <input formControlName="firstName" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                                    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                        <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                        <div *ngIf="f.firstName.errors">Numbers, Space and Special characters not
                                            allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="lastName">Last Name <span class="mandatory-fields">*</span></label>
                                    <input formControlName="lastName" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                    <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                        <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                        <div *ngIf="f.lastName.errors">Numbers, Space and Special characters not
                                            allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4  statusdivMain">
                                    <label for="firstname6">Status</label>
                                    <p-inputSwitch class="checkbox-mt-10" formControlName="status"></p-inputSwitch>
                                </div>
                                <!-- <div class="p-field p-col-4">
                                <label for="status">Status</label>
                                <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                    placeholder="Select" optionLabel="label"
                                    (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                    <div *ngIf="f.status.errors.required">Please, Select Status</div>
                                </div>
                            </div> -->
                                <div class="p-field p-col-4">
                                    <label for="mobileNumber">Mobile Number <span
                                            class="mandatory-fields">*</span></label>
                                    <input formControlName="mobileNumber" type="text" minlength="10" maxlength="12"
                                        pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
                                    <div *ngIf="submitted && f.mobileNumber.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobileNumber.errors.required">Mobile Number is required</div>
                                        <div *ngIf="f.mobileNumber.errors">Please Check Mobile Number</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="email">Email Id</label>
                                    <input formControlName="email" type="text" pInputText
                                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Email is required</div>
                                        <div *ngIf="f.email.errors.email">Enter valid email address</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="country">Country <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="country" [filter]="true" [options]="countrylist"
                                        formControlName="country" (onChange)="getStates('true',$event)"
                                        placeholder="Select" optionLabel="name"></p-dropdown>
                                    <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                        <div *ngIf="f.country.errors.required">Please, Select Country</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="state">State</label>
                                    <p-dropdown inputId="state" [filter]="true" [options]="statelist"
                                        formControlName="state" (onChange)="getCities('true', $event)"
                                        placeholder="Select" optionLabel="name"></p-dropdown>
                                    <!-- <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                            <div *ngIf="f.state.errors.required">Please, Select State</div>
                        </div> -->
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="city">City</label>
                                    <p-dropdown inputId="city" [filter]="true" [options]="citylist"
                                        formControlName="city" (onChange)="onCitySelect($event)" placeholder="Select"
                                        optionLabel="name"></p-dropdown>
                                    <!-- <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                            <div *ngIf="f.city.errors.required">Please, Select City</div>
                        </div> -->
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="zipcode">Zipcode</label>
                                    <input formControlName="zipcode" type="text" maxlength="10" pInputText
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }">
                                </div>
                                <div class="p-field p-col-8 ">
                                    <label for="textarea">Address</label>
                                    <textarea inputId="textarea" rows="3" cols="30" class="form-control"
                                        formControlName="address" pInputTextarea></textarea>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="textarea">Gender <span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="gender" [options]="genders" formControlName="gender"
                                        placeholder="Select" optionLabel="name" (ngModelChange)="onGenderSelect($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.gender.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                                        <div *ngIf="f.gender.errors.required">Please, Select Gender</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="dob">DOB <span class="mandatory-fields">*</span></label>
                                    <!-- <p-calendar #pCalendarId  class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"  [(ngModel)]="calvalue" ></p-calendar> -->
                                    <p-calendar formControlName="dob" class="p-calendar" monthNavigator="true"
                                        yearNavigator="true" yearRange="{{yearRange}}" inputId="calendar"
                                        dateFormat="dd-mm-yy" [defaultDate]="myDate" [showIcon]="true"
                                        (onSelect)="setDOB($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"></p-calendar>
                                    <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                        <div *ngIf="f.dob.errors.required">Please, Enter Dob</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="textarea">Timezone<span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="timezone" [options]="timeZoneArray" formControlName="timeZone"
                                        placeholder="Select" optionLabel="name"
                                        (ngModelChange)="onTimezoneSelect($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.timeZone.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.timeZone.errors" class="invalid-feedback">
                                        <div *ngIf="f.timeZone.errors.required">Please, Select TimeZone</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="textarea">Current Password</label>
                                    <input formControlName="currentPassword" (input)="newPasswordValidation($event)"
                                        placeholder="Enter Current Password" minlength="6" type="password" pInputText
                                        class="form-control">
                                    <div class="form-group col-md-12">
                                        <div *ngIf="cpassword" class="invalid-feedback">
                                            <div *ngIf="cpassword">Current Password required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="dob">New Password</label>
                                    <div class="form-inline">
                                        <input type="password" class="form-control" (input)="newPassword($event)"
                                            placeholder="Enter New Password" minlength="6" [style]="{'width':'100%'}"
                                            formControlName="password" pInputText
                                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                            <div *ngIf="f.password.errors">Password should contains at least 1 digit, 1
                                                lowercase, 1 uppercase, 1 symbol.
                                                Length between 6 to 20.</div>
                                        </div>
                                        <div *ngIf="newPasswordCheck" class="invalid-feedback">
                                            <div *ngIf="newPasswordCheck"> Password is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="textarea">Confirm New Password</label>
                                    <div class="form-inline">
                                        <input type="password" class="form-control" [style]="{'width':'100%'}"
                                            formControlName="confirmPassword" minlength="6" pInputText
                                            placeholder="Re-Enter New Password"
                                            [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                                        <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                            <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>

                            </div>
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4 uploadBtn">
                                    <div class="subTitleLable">
                                        <h4>Upload Profile Photo</h4>
                                    </div>

                                    <!-- <p-fileUpload name="myfiles[]" chooseLabel="Upload Profile Photo"
                                        uploadLabel="Show data" cancelLabel="Cancel" accept="image/*"
                                        maxFileSize="1000000" auto="auto" customUpload="true"
                                        (uploadHandler)="picUploader($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload> -->
                                    <p-fileUpload #fileUpload mode="advanced" name="file" chooseLabel="Upload Profile Photo"
                                        accept="image/*" [maxFileSize]="imageSize" [auto]="false" [customUpload]="true"
                                        [showUploadButton]="false" [showCancelButton]="false"
                                        (onSelect)="onFileSelect($event)" (onRemove)="onProfilePhotoRemove()">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload>
                                    <div class="instruction mt-3 mb-3">
                                        <p>Instructions: </p>
                                        <ul>
                                          <li>1) The cropped Profile Photo will be 512 x 512 px, with a maximum size
                                              of 1 MB.</li>
                                        </ul>
                                    </div>
                                    <div class="column banner-images col" *ngIf="showProfile && imageProfile">
                                        <div class="imagediv">
                                            <img class="thumbnail-image" src="{{ imageProfile }}" />
                                            <ul class="actionList">
                                                <li>
                                                    <button type="button" class="editBtn" (click)="fileUpload.choose()"><img
                                                            src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <!-- <img src="{{ imageProfile }}" alt="freya-layout" height="100px" /> -->
                                </div>
                            </div>
                        </div>




                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">

                            <div class="button-div d-flex">
                                <button type="submit" pButton pRipple label="Save" icon="pi pi-check"
                                    class="p-button-success save-btn p-mr-3" [disabled]="isSubmitting"></button>
                                <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                                <!-- <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"></button> -->
                                <button pButton pRipple type="button" icon="pi pi-times" label="Back"
                                    class="cancel-btn" (click)="backLink()"></button>
                            </div>
                        </div>


                    </form>
                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-dialog
        [(visible)]="cropDialog"
        [closable]="true"
        (onHide)="onDialogHide()"
        [modal]="true"
        [appendTo]="'body'"
        [style]="{width: '720px'}"
        [breakpoints]="{'768px': 'calc(100vw - 24px)'}"
        styleClass="custom-crop-dialog">
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
                    <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
                </div>
            </div>
        </ng-template>

        <div class="crop-dialog-content-wrapper">
            <div class="crop-toolbar-bar mb-3">
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
                   <div class="zoom-actions">
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
                        (click)="zoomIn()"></button>
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
                        (click)="zoomOut()"></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
                        (click)="resetZoom()"></button>
                </div>
            </div>

            <div class="cropper-frame mb-3">
                <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="1"
                    [resizeToWidth]="512"
                    [resizeToHeight]="512"
                    [onlyScaleDown]="false"
                    [imageQuality]="92"
                    [backgroundColor]="'#ffffff'"
                    [transform]="transform"
                    format="jpeg"
                    (imageCropped)="imageCropped($event)"
                    (loadImageFailed)="onCropImageLoadFailed()">
                </image-cropper>
            </div>

            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                <span>{{croppedImageError}}</span>
            </div>

            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Profile Photo Preview" class="preview-img" />
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times"
                    class="cancel-action-btn" (click)="onCropCancel()"></button>
                <button type="button" pButton label="Use Image" icon="pi pi-check"
                    class="use-image-btn" (click)="applyCrop()"
                    [disabled]="isApplyingCrop || !!croppedImageError || !croppedImage"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>

